import { type ComponentType, type ReactNode } from 'react'
import { styled } from '@mui/material/styles'

export const AvailableIntegrationsWrapper: ComponentType<{ children: ReactNode}> = styled( 'div' )( ( { theme } ) => ( {
	marginBottom: theme.spacing( 6 ),
} ) )
